import { MutationTree } from 'vuex';
import { ClaimState } from './types';

export const mutations: MutationTree<ClaimState> = {
    setData(state, payload: any) {
        state.data.claim = payload.data;
        state.loading = false;
    },
    setError(state, error: any) {
        state.error = true;
        state.data.claim = undefined;
        state.loading = false;
    },
    setLoading(state) {
        state.loading = true;
    },
    setCommentsData(state, payload: any) {
        state.data.comments = payload;
        state.commentsLoading = false;
    },
    setCommentsError(state, error: any) {
        state.commentsError = true;
        state.data.comments = undefined;
        state.commentsLoading = false;
    },
    setCommentsLoading(state) {
        state.commentsLoading = true;
    },
    setPaymentsData(state, payload: any) {
        for (const payment of payload.data) {
            payment.amount = Number(payment.amount);
        }
        state.data.payments = payload.data;
        state.paymentsLoading = false;
    },
    setPaymentsError(state, error: any) {
        state.paymentsError = true;
        state.data.payments = undefined;
        state.paymentsLoading = false;
    },
    setPaymentsLoading(state) {
        state.paymentsLoading = true;
    },
    setRemindersData(state, payload: any) {
        state.data.reminders = payload.data;
        state.remindersLoading = false;
    },
    setRemindersError(state, error: any) {
        state.remindersError = true;
        state.data.reminders = undefined;
        state.remindersLoading = false;
    },
    setRemindersLoading(state) {
        state.remindersLoading = true;
    },
    setAttachmentsData(state, payload: any) {
        state.data.attachments = payload.data;
        state.attachmentsLoading = false;
    },
    setAttachmentsError(state, error: any) {
        state.attachmentsError = true;
        state.data.attachments = undefined;
        state.attachmentsLoading = false;
    },
    setAttachmentsLoading(state) {
        state.attachmentsLoading = true;
    },
    setInterestsData(state, payload: any) {
        state.data.interests = payload;
        state.interestsLoading = false;
    },
    setInterestsError(state, error: any) {
        state.interestsError = true;
        state.data.interests = undefined;
        state.interestsLoading = false;
    },
    setInterestsLoading(state) {
        state.interestsLoading = true;
    },
};
